'use strict'

var encode = function (string) {
  return encodeURIComponent(string).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

module.exports = encode



//////////////////
// WEBPACK FOOTER
// ./~/encode-3986/index.js
// module id = 787
// module chunks = 0